module.exports = __webpack_public_path__ + "ef94dfdfb8ea4d6ee98c7b1b2f4cfa32.svg";